export default {
  title: "Designation",
  subtitle_create: "Create Item",
  subtitle_clone: "Clone Item",
  tab_overview: "Overview",
  tab_location: "Location",
  tab_data: "Data",
  tab_attached: "Attached",
  label_id: "ID",
  label_designation: "Designation",
  label_item_class: "Item Class",
  error_item_id: "There already exists an item with that ID",
  error_value_unique: "Value must be unique",
  error_attributes:
    "There was an error trying to create attributes. Please update them in the items overview page.",
  item_created: "Item successfully created",
}
